<div id="modal-HipaaLoadError" class="c-modal-material c-modal--confirm">
  <div class="c-modal__header">
    <h2 class="c-modal__heading" data-cy="hipaa-load-error-header">{{ 'HIPAA-CONSENT.hipaa_failed_to_load_alert_title' | translate }}</h2>
  </div>
  <div class="c-modal__footer">
    <div class="o-layout o-layout--auto@tablet">
      <div class="o-layout__item">
        <button class="c-btn c-btn--primary" type="button" data-cy="hipaa-load-error-ok-btn" (click)="close()">{{ 'MY-ACCOUNT/MY-PRIVACY.DownloadV2.Ok' | translate }}</button>
      </div>
    </div>
  </div>
</div>
